import React, { useState, useEffect} from 'react'
import { CustomerLoginDiv } from "./style";
import llogo from "../../../../assets/images/llogo.png";
import { Link, useHistory } from "react-router-dom";


function CustomerLogin() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const history= useHistory();

  useEffect(() => {
   if (localStorage.getItem('user-info')){
     history.push("/dashboard")
   }
    
  }, [])

  async function login(){
    console.warn(email,password)
    let item={email, password}

    let result = await fetch("http://localhost:8000/api/login" ,{
      method:'POST',
      headers:{
        "Content-Type":"application/json",
        "Accept":"application/json"
      },
      body: JSON.stringify(item)
    })
    result = await result.json();
    localStorage.setItem("user-info",JSON.stringify(result))
    history.push("/dashboard")

  }


  return (

    <CustomerLoginDiv>
      <div className=" row inner-container">
        <div className="col-md-6 left-div">
          <img src={llogo} alt="" />
          <h3>
            Welcome <span>Back!</span>
          </h3>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
        </div>

        <div className="col-md-6 right-div">
          <form>
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder=" Enter Email Address or Phone Number"
                onChange={(e)=>setEmail(e.target.value)}
              />
              <small id="emailHelp" className="form-text text-muted">
                We'll never share your email with anyone else.
              </small>
            </div>

            <div className="form-group">
              <input
                type="password"
                className="form-control"
                id="exampleInputPassword1"
                placeholder="Password"
                onChange={(e)=>setPassword(e.target.value)}
              />
            </div>

            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
                required
              />
              <label className="form-check-label" for="exampleCheck1">
                Checking the box shows you comply with medfirst's Terms and
                Condition{" "}
              </label>
            </div>

            <button onClick={login} type="submit" className="btn">
              Login 
            </button>
          </form>
          <div className="last-part">
            <h4>No Account?</h4>
            <Link to='/customer/register'>
              <h4>
                <span>Create Account</span>
              </h4>
            </Link>
          </div>
        </div>
      </div>
    </CustomerLoginDiv>
  );
}

export default CustomerLogin;
